import React, { useState } from "react";
import {
  Container,
  Box,
  Dialog,
  DialogContent,
  Typography,
  Button,
  Slide,
  IconButton,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// No longer need unused icon imports
import defaultLogo from "../assets/logo-img.png";
import MapComponent from "../components/MapComponent";
import StoreCard from "../components/StoreCard";

import banner1 from "../assets/banners_jomar/1.webp";
import banner2 from "../assets/banners_jomar/2.webp";
import banner3 from "../assets/banners_jomar/3.webp";
import banner4 from "../assets/banners_jomar/4.webp";
import banner5 from "../assets/banners_jomar/5.webp";

import { jomarStores } from "../components/MapComponent";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Home = () => {
  const [openInfo, setOpenInfo] = useState(true);
  const [currentBanner, setCurrentBanner] = useState(0);

  const banners = [banner1, banner2, banner3, banner4, banner5];

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
    }, 4000); // Change banner every 4 seconds
    return () => clearInterval(timer);
  }, [banners.length]);

  const handlePrevBanner = () => {
    setCurrentBanner((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  const handleNextBanner = () => {
    setCurrentBanner((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
  };

  const handleClose = () => {
    setOpenInfo(false);
  };

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        maxWidth: { xs: "100%", sm: "600px", md: "1200px" },
        minHeight: "100vh",
        pb: 0,
        px: { xs: 1.5, sm: 2, md: 3 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 auto",
        backgroundColor: "#fcfcfc",
      }}
    >
      {/* Banner Slider - Top */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "160px", sm: "220px", md: "300px" },
          overflow: "hidden",
          borderRadius: { xs: "12px", md: "20px" },
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          mt: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "100%",
            transition: "transform 0.5s ease-in-out",
            transform: `translateX(-${currentBanner * 100}%)`,
          }}
        >
          {banners.map((banner, idx) => (
            <Box
              key={idx}
              component="img"
              src={banner}
              alt={`Promoción Jomar ${idx + 1}`}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
          ))}
        </Box>

        {/* Left Arrow */}
        <IconButton
          onClick={handlePrevBanner}
          sx={{
            position: "absolute",
            top: "50%",
            left: 8,
            transform: "translateY(-50%)",
            backgroundColor: "rgba(255,255,255,0.7)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
            zIndex: 2,
          }}
          size="small"
        >
          <ArrowBackIosNewIcon fontSize="small" sx={{ color: "#e31837" }} />
        </IconButton>

        {/* Right Arrow */}
        <IconButton
          onClick={handleNextBanner}
          sx={{
            position: "absolute",
            top: "50%",
            right: 8,
            transform: "translateY(-50%)",
            backgroundColor: "rgba(255,255,255,0.7)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
            zIndex: 2,
          }}
          size="small"
        >
          <ArrowForwardIosIcon fontSize="small" sx={{ color: "#e31837" }} />
        </IconButton>

        {/* Indicators */}
        <Box
          sx={{
            position: "absolute",
            bottom: 8,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: 1,
            zIndex: 2,
          }}
        >
          {banners.map((_, idx) => (
            <Box
              key={idx}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor:
                  currentBanner === idx ? "#e31837" : "rgba(255,255,255,0.7)",
                transition: "background-color 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() => setCurrentBanner(idx)}
            />
          ))}
        </Box>
      </Box>

      {/* Header with Logo and Title */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 2, md: 3 },
          pb: 2,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: 90, md: 110 },
            height: { xs: 90, md: 110 },
            borderRadius: "50%",
            backgroundColor: "white",
            border: "4px solid white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            mb: 2,
          }}
        >
          <img
            src={require("../assets/joma/logojomar.png")}
            alt="Jomar Logo"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ mb: 0.5, color: "#1a1a1a" }}
        >
          Jomar Autopartes
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "#666", fontSize: "0.95rem", mb: 2 }}
        >
          Selecciona tu sucursal más cercana y crea tu pedido
        </Typography>
      </Box>

      {/* Map and Stores Section - Flex Layout */}
      <Box
        sx={{
          width: "100%",
          flexGrow: 1,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          px: 0,
          mb: { xs: 2, md: 4 },
          gap: { xs: 2, md: 4 },
        }}
      >
        {/* Left Side: Store Blocks */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr 1fr", md: "1fr 1fr" },
            gap: { xs: 1.5, md: 2 },
            alignContent: "start",
            order: { xs: 2, md: 1 },
          }}
        >
          {jomarStores.map((store) => (
            <StoreCard key={store.id} store={store} />
          ))}
        </Box>

        {/* Right Side: Map Component */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" }, // 50% width on desktop
            display: "flex",
            flexDirection: "column",
            order: { xs: 1, md: 2 }, // On mobile it's first (top), on desktop it's second (right)
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              minHeight: { xs: "280px", sm: "360px", md: "500px" },
              width: "100%",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <MapComponent />
          </Box>
        </Box>
      </Box>

      {/* Intro Modal / Pop-up */}
      <Dialog
        open={openInfo}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "24px",
            padding: "24px 16px",
            maxWidth: "400px",
            width: "90%",
            textAlign: "center",
            boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogContent sx={{ overflowY: "visible", p: 1 }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ mb: 4, color: "#1a1a1a" }}
          >
            ¿Cómo funciona?
          </Typography>

          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 3.5, mb: 4 }}
          >
            {/* Step 1 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#0d4094", // Jomar Blue
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                }}
              >
                1
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Ubica tu sucursal más cercana en el mapa
              </Typography>
            </Box>

            {/* Step 2 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#0d4094", // Jomar Blue
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                }}
              >
                2
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Selecciona la sucursal para ver sus detalles
              </Typography>
            </Box>

            {/* Step 3 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#0d4094", // Jomar Blue
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                }}
              >
                3
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Visítanos y encuentra tus autopartes
              </Typography>
            </Box>
          </Box>

          <Button
            fullWidth
            variant="contained"
            onClick={handleClose}
            sx={{
              mt: 2,
              backgroundColor: "#e31837", // Jomar Red
              color: "white",
              borderRadius: "16px",
              padding: "14px",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              "&:hover": {
                backgroundColor: "#c6112a",
              },
            }}
          >
            ¡Entendido!
          </Button>
        </DialogContent>
      </Dialog>

      {/* Footer Powered by mennu.mx */}
      <Box
        sx={{
          mt: "auto",
          pt: 2,
          pb: 2,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <a
          href="https://mennu.mx"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            backgroundColor: "#FFFFFF",
            borderRadius: "12px", // Slightly smaller border radius to match smaller size
            padding: "8px 20px", // Reduced padding
            margin: "0 auto",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", // Softer shadow
            maxWidth: "fit-content",
            gap: "2px", // Tightened gap between text and logo
          }}
        >
          <div
            style={{
              color: "#555555", // Slightly lighter gray so it's less dominant
              fontSize: "11px", // Much smaller font
              fontFamily: '"Montserrat", sans-serif',
              fontWeight: "bold", // Changed to bold
              textAlign: "center",
              whiteSpace: "nowrap",
            }}
          >
            Powered by
          </div>
          <img
            src={defaultLogo}
            alt="Mennu.mx logo"
            style={{
              height: "22px", // Much smaller logo (from 36px)
              width: "auto",
              display: "block",
            }}
          />
        </a>
      </Box>
    </Container>
  );
};

export default Home;
